export const AvatarModes = {
  illustration: "ILLUSTRATION",
  profileImage: "PROFILE_IMAGE"
};
